import React from 'react'
import { Box, Grid, Paper } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { isEmpty } from 'lodash'

import ComingSoon from '../coming-soon/ComingSoon'
import Delivery from './Delivery'
import NoDeliveriesToday from './NoDeliveriesToday'

const HomeDeliveries = ({
  isAuthenticated,
  deliveries,
  loading,
  selectedDate,
  errorLoading,
  friendHasOrdered,
  isSelectedDayActive,
  isWebpSupported,
  locationId,
  activationDate,
  selectDateStart,
}) => {
  if (loading) {
    return <SkeletonLoading />
  }

  const hasDeliveries = !isEmpty(deliveries)
  const isNewBuilding = !isSelectedDayActive && activationDate
  return (
    <>
      {errorLoading && <LoadingErrorState />}

      {hasDeliveries && (
        <Delivery
          deliveries={deliveries}
          friendHasOrdered={friendHasOrdered}
          isSelectedDayActive={isSelectedDayActive}
          isWebpSupported={isWebpSupported}
          locationId={locationId}
          selectedDate={selectedDate}
        />
      )}

      {isNewBuilding && (
        <ComingSoon
          activationDate={activationDate}
          isAuthenticated={isAuthenticated}
          locationId={locationId}
          onChangeDay={date => selectDateStart(date, locationId)}
        />
      )}

      {!hasDeliveries && !isNewBuilding && <NoDeliveriesToday selectedDate={selectedDate} />}
    </>
  )
}

const SkeletonLoading = () => (
  <>
    <SkeletonLoadingCard />
    <SkeletonLoadingCard logoShape="circle" />
    <SkeletonLoadingCard logoShape="circle" />
    <SkeletonLoadingCard />
    <SkeletonLoadingCard />
  </>
)

const SkeletonLoadingCard = ({ logoShape }) => {
  return (
    <Box marginBottom={3}>
      <Paper color="secondary" variant="outlined">
        <Box alignItems="center" display="flex" minHeight="140px" padding={2}>
          <Grid alignItems="center" container justifyContent="center">
            <Grid item md={4} xs={12}>
              <Box display="flex" justifyContent="center">
                <Skeleton height={100} variant={logoShape} width={100} />
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <Skeleton height={40} />
              <Grid container justifyContent="flex-start">
                <Grid item xs={4}>
                  <Skeleton height={10} width={80} />
                  <Skeleton height={30} width={100} />
                </Grid>
                <Grid container item justifyContent="center" xs={1}>
                  <Skeleton height="100%" width={3} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton height={10} width={80} />
                  <Skeleton height={30} width={100} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  )
}

const LoadingErrorState = () => (
  <div className="center-xs">
    <h5 className="error center-xs">
      <i className="icon-warning" /> Oops! Something went wrong.
    </h5>
    <p>
      Try refreshing the page or switching between days. If this problem persists, please{' '}
      <a href={`/contact`}>contact support</a>
    </p>
  </div>
)

export default HomeDeliveries
